import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useClickOutside } from '../../_hooks';
import { WorldActions } from '../../_actions';
import { SubGroupItem } from '.';
import { Icon } from '..';
import ReactTooltip from 'react-tooltip';

export function SubGroupPicker({ subGroups, value, onChange }) {
  let [availableSubGroups, setAvailableSubGroups] = useState(subGroups || []);
  let [filteredSubGroups, setFilteredSubGroups] = useState([]);
  let [selectedSubGroups, setSelectedSubGroups] = useState(
    Array.isArray(value) ? value : []
  );
  let [searchTerm, setSearchTerm] = useState('');
  console.log('SUB GROUP INIT VAL', value);
  const { details: world } = useSelector((state) => state.world);

  const dispatch = useDispatch();

  const inputRef = useRef();

  //Effect: Load Subgroups
  useEffect(() => {
    //...fetch subgroups
    if (!world || !world.waID) return;
    dispatch(WorldActions.getSubGroups(world.waID)).then((subGroups) => {
      setAvailableSubGroups(subGroups);
      setFilteredSubGroups(subGroups);
      ReactTooltip.rebuild();
    });
    //...put groups in availableSubGroups
  }, []);

  useEffect(() => {
    //...filter groups
    if (searchTerm && searchTerm.length > 0) {
      let results = availableSubGroups.filter((sg) => {
        return (
          sg.id.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
          sg.title.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())
        );
      });
      setFilteredSubGroups(results);
      return;
    }
    setFilteredSubGroups(availableSubGroups);
    //...set filteredSubGroups
  }, [searchTerm]);

  useEffect(() => {
    if (onChange) onChange(selectedSubGroups);
  }, [selectedSubGroups]);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [selectedSubGroups]);

  const handleSearchChange = () => {
    if (!inputRef || !inputRef.current) return;
    const { value } = inputRef.current;
    setSearchTerm(value);
  };

  const handleSelect = (subGroup) => {
    if (selectedSubGroups.find((sg) => sg === subGroup.id)) {
      setSelectedSubGroups((prev) => prev.filter((sg) => sg !== subGroup.id));
      return;
    }
    setSelectedSubGroups((prev) => [...prev, subGroup.id]);
  };
  // ReactTooltip.rebuild();

  return (
    <div className="chronos-subscriber-group-picker-component">
      

      <div className="chronos-subgroup-list-section">
        <div className="chronos-subgroup-list">
          {/* <p className="chronos-subgroup-list-header">Subscriber Groups</p> */}
          <div className="chronos-subgroup-search">
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          ref={inputRef}
          placeholder="Search Subscriber Groups"
          className='chronos-input'
        />
        <Icon icon="far fa-search fa-fw text-muted" />
      </div>
          {/*  */}
          <div className="chronos-subgroup-list-content">
            {filteredSubGroups
              .filter((fg) => !selectedSubGroups.includes(fg.id))
              .map((group) => (
                <SubGroupItem
                  key={group.id}
                  group={group}
                  onSelect={handleSelect}
                >
                  {group.title}
                </SubGroupItem>
              ))}
          </div>
        </div>
        <div className="chronos-subgroup-list">
          {/* <p className="chronos-subgroup-list-header">
            Allowed Groups&nbsp;
            <Icon
              icon="far fa-question-circle fa-fw"
              data-tip="The Subscriber Groups below will have access to this content."
              data-for="chronosSubGroupComponentTooltip"
            />
          </p> */}
          <div className="chronos-subgroup-list-content">
            {selectedSubGroups &&
              selectedSubGroups.map((g) => {
                let group = availableSubGroups.find((sg) => sg.id === g);
                if (!group) return null;
                // console.log('Group: ', g, group);
                return (
                  <SubGroupItem
                    key={group.id}
                    group={group}
                    onSelect={handleSelect}
                    isSelected
                  >
                    {group.title}
                  </SubGroupItem>
                );
              })}
          </div>
        </div>
      </div>
      <ReactTooltip effect="solid" id="chronosSubGroupComponentTooltip" />
    </div>
  );
}
